import { emitWebSocketEvent } from "@/emitWebSocketEvent";

export function useQueueUpdateCountAttendance() {
  async function updateCountAttendance(companyId: number) {
    try {
      if (!companyId) return;

      // Emite o evento e automaticamente desconecta após a emissão
      await emitWebSocketEvent("updateCountInAttendance", {
        company: {
          id: companyId
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  return { updateCountAttendance };
}
